export const justValidateGlobalDefaults = {
    errorFieldCssClass: ['is-invalid'],
    errorLabelCssClass: ['invalid-feedback', 'd-block'],
    successFieldCssClass: ['is-valid'],
    successLabelCssClass: ['valid-feedback', 'd-block'],
};

export default justValidateGlobalDefaults;